export type QuantityRecommendationTargetType = {
  uniqueId: string;
  recommendedQuantity?: number;
};

export type DistributedQuantityType = {
  uniqueId: string;
  quantity: number;
};

export function distributeQuantityAcrossRecommendations(
  totalQuantity: number,
  recommendations: QuantityRecommendationTargetType[]
): DistributedQuantityType[] {
  let remaining = totalQuantity;
  const distributed: DistributedQuantityType[] = [];
  recommendations.forEach((rec) => {
    if (remaining <= 0) return;
    const qty = Math.min(rec.recommendedQuantity ?? 1, remaining);
    remaining -= qty;
    distributed.push({ uniqueId: rec.uniqueId, quantity: qty });
  });
  return distributed;
}
